import { render, staticRenderFns } from "./OwnerSelect.vue?vue&type=template&id=0ffffdc6&scoped=true&"
import script from "./OwnerSelect.vue?vue&type=script&lang=ts&"
export * from "./OwnerSelect.vue?vue&type=script&lang=ts&"
import style0 from "./owner-select.scss?vue&type=style&index=0&id=0ffffdc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffffdc6",
  null
  
)

export default component.exports